/**
 * 엣지 크롤 도달과 인용 건수 — 축이 둘이다 (260928-oai-searchbot-is-the-index-gate).
 *
 * ★ **끊긴 구간은 0 이 아니라 "수집 안 됨"이다.** Cloudflare 보존이 ~5~6일이라 그 앞은 데이터가
 *   아예 없다. `connectNulls={false}` 로 끊어 그려서 0 과 눈으로 갈린다.
 * ★ 인용은 **건수**다. 비율로 그리면 분모(전체 적격 샘플)가 고객·질문이 늘 때 커져서
 *   크롤·인용이 그대로여도 선이 내려간다.
 */
import { Area, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

export interface CrawlPoint {
  date: string;
  crawl: { page: number; aiSearch: number } | null;
  cited: { k: number; n: number } | null;
}

export function CrawlTrend({ daily }: { daily: CrawlPoint[] }) {
  const data = daily.map((d) => ({
    date: d.date.slice(5),
    page: d.crawl?.page ?? null,
    aiSearch: d.crawl?.aiSearch ?? null,
    cited: d.cited?.k ?? null,
    n: d.cited?.n ?? null,
    collected: d.crawl !== null,
  }));
  return (
    <div className="h-72 w-full">
      <ResponsiveContainer>
        <ComposedChart data={data} margin={{ top: 10, right: 8, bottom: 0, left: -10 }}>
          <CartesianGrid stroke="#e2e8f0" vertical={false} />
          <XAxis dataKey="date" tick={{ fontSize: 12 }} />
          <YAxis yAxisId="crawl" tick={{ fontSize: 12 }} allowDecimals={false} />
          <YAxis yAxisId="cite" orientation="right" tick={{ fontSize: 12 }} allowDecimals={false} width={34} />
          <Tooltip
            formatter={(v, name, item) => {
              const p = item.payload as (typeof data)[number];
              if (name === '인용') return [p.cited === null ? '표본 없음' : `${p.cited}건 / 샘플 ${p.n}`, name];
              if (!p.collected) return ['수집 안 됨', name];
              return [`${Number(v).toLocaleString()}회`, name];
            }}
          />
          <Legend verticalAlign="top" height={28} iconType="plainline" wrapperStyle={{ fontSize: 12 }} />
          <Area
            yAxisId="crawl"
            name="페이지 요청"
            dataKey="page"
            stroke="#cbd5e1"
            fill="#cbd5e1"
            fillOpacity={0.35}
            isAnimationActive={false}
            connectNulls={false}
          />
          <Line
            yAxisId="crawl"
            name="AI Search"
            dataKey="aiSearch"
            stroke="#0ea5e9"
            strokeWidth={2}
            isAnimationActive={false}
            connectNulls={false}
            dot={{ r: 3 }}
          />
          <Line
            yAxisId="cite"
            name="인용"
            dataKey="cited"
            stroke="var(--color-brand)"
            strokeWidth={2}
            isAnimationActive={false}
            connectNulls={false}
            dot={{ r: 4 }}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
